export default __webpack_public_path__ + "assets/images/setup-an-action-cc200e7b5ab738457e2d657b1528fdf5.png";